<template>
  <div>
    <b-col style="cursor: pointer" @click="$router.go(-1)" md="12" cols="12">
      <statistic-card-horizontal
        icon=""
        :statistic="$t('common.go-back')"
        class="modify"
      />
    </b-col>
    <b-card :title="$t('surgery.Create-Surgery')">
      <b-card-text>
        <b-row>
          <b-col cols="12" class="my-3">
            <b-form-checkbox
              v-model="EditForm.money_collected"
              name="checkbox-1"
            >
              {{ $t("surgery.dose-receved-money") }}
            </b-form-checkbox>
          </b-col>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group label="Doctors">
              <v-select
                v-model="selectedDoctors"
                :options="doctors"
                multiple
                label="name"
                :reduce="(doctor) => doctor"
                :close-on-select="false"
              >
                <template #option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-primary">
                      ({{
                        type == "surgeon"
                          ? $t("hospital.surgeon")
                          : $t("hospital.anesthetist")
                      }})
                    </span>
                  </b>
                </template>
                <template #selected-option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-success">
                      ({{
                        type == "surgeon"
                          ? $t("hospital.surgeon")
                          : $t("hospital.anesthetist")
                      }})
                    </span>
                  </b>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="12" cols="12" class="mb-1">
            <div class="my-1">
              <p class="mb-0">
                {{ $t("reception.available-surgeries-for-doctors") }}
                (<span class="text-danger font-weight-bold">{{
                  doctorsName
                }}</span>
                )
              </p>
              <v-select
                v-model="selectedAvailableSurgeries"
                :options="availableSurgeriesOptions"
                :placeholder="$t('reception.available-surgeries-for-doctors')"
                label="title"
                ><template #list-footer>
                  <b-button
                    variant="success"
                    @click="showCreateSurgeryModal"
                    size="sm"
                    block
                  >
                    {{ $t("reception.create-surgery") }}
                  </b-button>
                </template>
              </v-select>
            </div>
          </b-col>

          <b-modal
            id="modal-create-surgery"
            :title="$t('reception.create-surgery')"
            ok-only
            centered
            size="lg"
            :no-close-on-backdrop="true"
          >
            <div>
              <b-form-group :label="$t('common.title')">
                <b-form-input v-model="surgeryForm.title" />
              </b-form-group>
              <b-form-group :label="$t('common.description')">
                <b-form-textarea v-model="surgeryForm.description" />
              </b-form-group>
              <b-form-group :label="$t('reception.type')">
                <v-select
                  v-model="surgeryForm.type"
                  :options="surgeryTypesList"
                  label="text"
                  :reduce="(option) => option.value"
                />
              </b-form-group>
            </div>
            <template #modal-footer="{}">
              <b-button
                variant="primary"
                @click="createSurgery"
                class="m-0"
                :disabled="loading"
                ref="button"
                block
              >
                <span v-if="!loading">{{ $t("common.add") }}</span>
                <b-spinner small v-else></b-spinner>
              </b-button>
            </template>
          </b-modal>

          <b-col md="12">
            <div>
              <b-form-group :label="$t('common.date')" label-for="Date">
                <datetime
                  input-class="form-control"
                  type="datetime"
                  v-model="date"
                >
                </datetime>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-card :title="$t('surgery.Doctor Assist Info')">
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12">
            <b-form-group :label="$t('surgery.doctor-assistants')">
              <v-select
                v-model="selectedDoctorAssistants"
                :options="doctorAssistants"
                multiple
                :close-on-select="false"
              >
                <template #option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-primary">
                      ({{
                        type == "surgeon_assistant"
                          ? $t("hospital.surgeon-assistant")
                          : $t("hospital.anesthetist-assistant")
                      }})
                    </span>
                  </b>
                </template>
                <template #selected-option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-success">
                      ({{
                        type == "surgeon_assistant"
                          ? $t("hospital.surgeon-assistant")
                          : $t("hospital.anesthetist-assistant")
                      }})
                    </span>
                  </b>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-card :title="$t('surgery.Surgery Staff')">
      <b-card-text>
        <b-row>
          <b-col lg="10">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                id="name"
                v-model="doctorAssistName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>

          <b-col lg="2" class="d-flex align-items-center">
            <b-button ref="myButton" variant="primary" @click="addDoctorAssist">
              {{ $t("common.add") }}
            </b-button></b-col
          >
        </b-row>
      </b-card-text>
      <b-table
        v-if="EditForm.doctor_assist.length > 0"
        :items="EditForm.doctor_assist"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative mt-2"
      >
        <template #cell(actions)="data">
          <b-button
            size="sm"
            variant="danger"
            @click="removeDoctorAssist(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
    </b-card>

    <b-card :title="$t('emergency.Patient Medical Info')">
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('reception.patient-case')"
              label-for="diagnosis"
            >
              <b-form-textarea
                id="diagnosis"
                v-model="patientCardData.patient_case"
                :placeholder="$t('reception.patient-case')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.diagnosis')"
              label-for="diagnosis"
            >
              <b-form-textarea
                id="diagnosis"
                v-model="patientCardData.diagnosis"
                :placeholder="$t('reception.diagnosis')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.investigation')"
              label-for="investigation"
            >
              <b-form-textarea
                id="investigation"
                v-model="patientCardData.investigation"
                :placeholder="$t('reception.investigation')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.examination')"
              label-for="examination"
            >
              <b-form-textarea
                id="examination"
                v-model="patientCardData.examination"
                :placeholder="$t('reception.examination')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Treatment" label-for="treatment">
              <b-form-textarea
                id="treatment"
                v-model="patientCardData.treatment"
                placeholder="Treatment"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-card :title="$t('surgery.surgery-procedure')">
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('surgery.procedure')"
              label-for="Case_Details"
            >
              <b-form-textarea
                id="procedure"
                v-model="EditForm.procedure"
                :placeholder="$t('surgery.procedure')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card :title="$t('surgery.patient-surgery-consumables')">
      <b-card-text>
        <b-row>
          <b-col lg="3">
            <CategoryModal @category="assignCategory" />
          </b-col>
          <b-col v-if="sciFilter" lg="3">
            <AutoComplete
              :label="$t('surgery.consumables')"
              :placeholder="`${$t('common.select')} ${$t(
                'surgery.consumable'
              )}`"
              v-model="EditForm.item_id"
              param-query="search"
              :serializer="(val) => val"
              endpoint="item"
              text-title="name"
              :otherQuery="`filter[category_id]=${sciFilter}`"
            />
          </b-col>

          <b-col lg="2">
            <b-form-group :label="$t('pharmacy.Quantity')" label-for="Quantity">
              <b-form-input
                type="number"
                id="Quantity"
                v-model="EditForm.quantity"
                :placeholder="$t('pharmacy.Quantity')"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col lg="2">
            <b-form-group :label="$t('common.price')" label-for="Price">
              <b-form-input
                type="number"
                id="Price"
                v-model="EditForm.priceConsumables"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col> -->
          <b-col lg="2">
            <b-button
              :disabled="!EditForm.item_id"
              class="mt-2"
              ref="myButton"
              variant="primary"
              @click="addToConsumablesList"
            >
              {{ $t("common.add") }}
            </b-button></b-col
          >
        </b-row>
        <!-- <div class="d-flex justify-content-end">
          <b-button
            class="mt-2"
            ref="myButton"
            variant="primary"
            @click="addToConsumablesList"
          >
            {{ $t('common.add') }}
          </b-button>
        </div> -->
      </b-card-text>
      <b-table
        :items="EditForm.consumables"
        responsive
        :fields="consumablesTable"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
    </b-card>
    <div class="d-flex justify-content-end">
      <b-button
        style="z-index: 10000; height: 50px; width: 200px"
        class="mt-2"
        ref="myButton"
        variant="primary"
        @click="submitItem"
      >
        {{ $t("common.submit") }}
      </b-button>
    </div>
    <!-- <b-card :title="$t('pharmacy.drugs')">
      <b-table
        :items="drugs"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="drugs.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t("common.submit") }}
        </b-button>
      </div>
    </b-card> -->
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BFormTextarea,
  BFormCheckbox,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import vSelect from "vue-select";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    CategoryModal,
    Datetime,
    DeleteModal,
    ActionsButtons,
    vSelect,
    BFormTextarea,
    StatisticCardHorizontal,
    BFormCheckbox,
  },

  props: ["patientCardId"],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      surgeryId: null,
      surgery: {},
      dataCount: 0,
      data: [],
      date: new Date(Date.now()).toISOString(),

      doctorAssistName: "",
      sciFilter: null,
      categoryFilter: {
        name: "",
        id: "",
      },
      surgeryStaffId: "",
      surgeryStaffType: "",
      EditForm: {
        patient_card_id: "",
        doctor_surgery_id: "",
        surgery_date_time: "",
        surgery_id: "",
        item_id: "",
        quantity: "",
        procedure: "",
        doctor_assist: [],
        surgery_staff: [],
        consumables: [],
        money_collected: true,
        _method: "POST",
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        doctor_surgery_id: "",
        surgery_id: "",
        surgery_date_time: "",
      },
      doctors: [],
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "name",
          label: this.$t("common.name"),
          sortable: true,
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      consumablesTable: [
        { key: "item_id.name", label: this.$t("common.name"), sortable: true },

        {
          key: "quantity",
          label: this.$t("pharmacy.Quantity"),
          sortable: true,
        },

        // { key: "price", label: this.$t("common.price"), sortable: true },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      staffTableColumns: [
        {
          key: "employee_id",
          label: this.$t("common.name"),
          sortable: true,
        },
        {
          key: "anesthetist_type",
          label: this.$t("common.type"),
          sortable: true,
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      staffData: [],
      patientCardData: {},
      filters: "",
      surgeryList: [],
      availableSurgeries: [],
      availableSurgeriesOptions: [],
      selectedAvailableSurgeries: "",
      doctorsId: "",
      doctorsName: "",
      surgeryForm: {
        title: "",
        description: "",
        type: 0,
        price: 0,
      },
      surgeryTypesList: [
        {
          text: "كبرى ",
          value: "1",
        },
        {
          text: "صغرى ",
          value: "2",
        },
        {
          text: "متوسطة",
          value: "3",
        },
        {
          text: "فوق الكبرى",
          value: "4",
        },
        {
          text: "خاصة",
          value: "5",
        },
      ],
      paramsForSurgery: {
        form: {
          title: "",
          description: "",
          type: 0,
          price: 0,
        },
        path: "/surgery",
      },
      paramsForDoctorSurgery: {
        form: {
          doctor_id: "",
          surgery_id: "",
          price: 0,
        },
        path: "/doctorSurgery",
      },
      selectedDoctors: [],
      doctorAssistants: [],
      selectedDoctorAssistants: [],
    };
  },

  mounted() {
    this.getPatientCard();
    this.getDoctors();
    if (this.$route.query.isSub) {
      this.getPatientSurgeryInfo();
    }
    this.getDoctorAssistants();
  },
  watch: {
    selectedDoctors() {
      console.log("selectedDoctors", this.selectedDoctors);
      this.formatForQuery(this.selectedDoctors);
    },
  },
  methods: {
    async getDoctors() {
      await this.getList("doctor?take=100").then((response) => {
        this.doctors = response.data.data.map((doctor) => ({
          id: doctor.id,
          name: doctor.name,
          type: doctor.type,
        }));
      });
    },
    async formatForQuery(val) {
      this.doctorsName = this.getDoctorsName(val);
      this.availableSurgeriesOptions = [];
      let temp = ``;
      val.forEach((item) => {
        temp += `doctors[]=${item.id}&`;
      });
      this.doctorsId = temp;
      console.log("doctorsId", this.doctorsId);
      await this.getList(
        `surgery/availableSurgeriesForDoctors?${this.doctorsId}`
      );
      this.availableSurgeries = this.all_data;
      this.availableSurgeries.forEach((item) => {
        this.availableSurgeriesOptions.push({
          id: item.id,
          title: item.title,
        });
      });
      console.log("availableSurgeries", this.availableSurgeries);
    },
    getDoctorsName(doctors) {
      let temp = "";
      doctors.forEach((item) => {
        temp += item.name + ", ";
      });
      return temp;
    },
    showCreateSurgeryModal() {
      this.$bvModal.show("modal-create-surgery");
    },
    async createSurgery() {
      this.loading = true;
      try {
        this.paramsForSurgery.form = this.surgeryForm;
        this.paramsForSurgery.path = "/surgery";
        this.$store
          .dispatch("create", this.paramsForSurgery)
          .then(async (surgeryResponse) => {
            console.log("surgeryResponse", surgeryResponse);
            console.log("selectedDoctors", this.selectedDoctors);
            // Link doctors to the created surgery
            const doctorSurgeryPromises = this.selectedDoctors.map((doctor) => {
              this.paramsForDoctorSurgery.form = {
                doctor_id: doctor.id,
                surgery_id: surgeryResponse.data.data.id,
                price: 0,
              };
              this.paramsForDoctorSurgery.path = "/doctorSurgery";
              return this.$store.dispatch(
                "create",
                this.paramsForDoctorSurgery
              );
            });

            await Promise.all(doctorSurgeryPromises);
            this.loading = false;
            this.$bvModal.hide("modal-create-surgery");
            await this.formatForQuery(this.selectedDoctors);
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Success",
                variant: "success",
                text: this.$t(
                  "reception.surgery-created-and-linked-to-doctors-successfully"
                ),
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                variant: "danger",
                text:
                  error.response?.data?.message ||
                  this.$t(
                    "reception.surgery-created-and-linked-to-doctors-error"
                  ),
              },
            });
          });
      } catch (error) {
        console.log("error", error);
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text:
              error.response?.data?.message ||
              this.$t("reception.surgery-created-and-linked-to-doctors-error"),
          },
        });
      }
    },
    async createPatientSurgery(response) {
      if (!this.selectedAvailableSurgeries) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: this.$t("reception.surgery-creation-error"),
          },
        });
        return;
      }
      try {
        //   "-" +
        //   String(now.getDate()).padStart(2, "0") +
        //   " " +
        //   String(now.getHours()).padStart(2, "0") +
        //   ":" +
        //   String(now.getMinutes()).padStart(2, "0");

        const surgeryPayload = {
          patient_card_id: this.$route.params.id,
          surgery_id: this.selectedAvailableSurgeries.id,
          surgery_date_time: this.date.replace(/T/, " ").substring(0, 16),
          doctors: this.selectedDoctors.map((doctor) => {
            return {
              id: doctor.id,
              type: doctor.type,
            };
          }),
          doctor_assist: this.selectedDoctorAssistants.map((assistant) => {
            return {
              id: assistant.id,
              type: assistant.type,
            };
          }),
          money_collected: this.EditForm.money_collected === true ? 1 : 0,
        };

        await this.$store.dispatch("create", {
          form: surgeryPayload,
          path: "patient-surgery",
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Surgery Scheduled",
            variant: "success",
          },
        });
        this.$router.push({
          name: "surgery-patient-history",
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Surgery Creation Error",
            variant: "danger",
            text: error.response?.data,
            // ||
            // this.$t("reception.surgery-creation-error"),
          },
        });
        throw error; // Re-throw error if you need to handle it in the caller
      }
    },

    //old methods////////////////////////////////////////////////////////////
    addDoctorAssist() {
      this.EditForm.doctor_assist.push({
        name: this.doctorAssistName,
      });
      this.doctorAssistName = "";
    },

    async getPatientCard() {
      this.loading = true;
      await this.getPatient(
        `active-card/patient/${this.$route.query.patientId}?include=patient,doctors,surgeries`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientCardData = this.all_data.data;
      // this.generateDoctorQuery();
      this.setDoctors();
      // this.generateDoctorQuery();
    },
    async getPatientSurgeryInfo() {
      await this.getPatient(
        `patient-surgery?filter[patient_card_id]=${this.$route.params.id}&include=surgery`
      );
      this.surgeryList = this.all_data.data.map((item) => ({
        title: item.surgery.title,
        value: item.id,
      }));
    },
    addDoctor() {
      this.doctors.push("");
      this.generateDoctorQuery();
    },

    removeDoctor(index) {
      if (index === 0) return;
      this.doctors.splice(index, 1);
      this.generateDoctorQuery();
    },
    setDoctors() {
      if (
        this.patientCardData.doctors &&
        this.patientCardData.doctors.length > 0
      ) {
        this.selectedDoctors = [
          ...this.patientCardData.doctors.map((doctor) => ({
            id: doctor.id,
            name: doctor.name,
            type: "surgeon",
          })),
        ];
        console.log("doctors", this.selectedDoctors);
        this.formatForQuery(this.patientCardData.doctors);
      } else {
        this.selectedDoctors = [];
      }
    },
    async generateDoctorQuery() {
      const query = this.doctors
        .filter((id) => id)
        .map((id) => `doctors[]=${id}`)
        .join("&");
      await this.getList(`/surgery/availableSurgeriesForDoctors?${query}`);

      this.filters = this.all_data;
    },
    assignCategory(v) {
      this.EditForm.item_id = null;
      this.sciFilter = v.id;
    },
    addSurgeryStaff() {
      this.staffData.push({
        employee_id: this.surgeryStaffId,
        anesthetist_type: this.surgeryStaffType,
      });
      this.EditForm.surgery_staff.push({
        employee_id: this.surgeryStaffId.id,
        anesthetist_type: this.surgeryStaffType,
      });
      this.surgeryStaffId = "";
      this.surgeryStaffType = "";
    },

    addToConsumablesList() {
      this.EditForm.consumables.push({
        item_id: this.EditForm.item_id,
        quantity: this.EditForm.quantity,
        price: 0,
      });
      this.sciFilter = null;
      this.EditForm.quantity = 0;
      this.EditForm.priceConsumables = 0;
    },

    removeDoctorAssist(item) {
      this.EditForm.doctor_assist = this.EditForm.doctor_assist.filter(
        (doctor_assist) => doctor_assist !== item
      );
    },
    removeStaffItem(item) {
      this.EditForm.surgery_staff = this.EditForm.surgery_staff.filter(
        (surgery_staff) => surgery_staff !== item
      );
    },
    removeItem(item) {
      this.EditForm.consumables = this.EditForm.consumables.filter(
        (consumable) => consumable !== item
      );
    },
    formatNewDate(surgeryDate) {
      const date = new Date(surgeryDate);

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // JavaScript months are 0-based
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    submitItem() {
      this.EditForm.surgery_id = this.selectedAvailableSurgeries.id;
      let count = 0;
      this.loading = true;
      this.errorForm.surgery_id = "";
      if (!this.EditForm.surgery_id && this.patientCardData) {
        count++;
        this.errorForm.surgery_id = "The surgery field is required.";
      }
      if (count > 0) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "validation error",
            variant: "danger",
            text: this.errorForm.surgery_id,
          },
        });
        this.loading = false;
        return false;
      }
      this.EditForm.consumables = this.EditForm.consumables.map((item) => ({
        ...item,
        item_id: item.item_id.id,
      }));
      this.EditForm.patient_case = this.patientCardData.patient_case;
      this.EditForm.examination = this.patientCardData.examination;
      this.EditForm.treatment = this.patientCardData.treatment;
      this.EditForm.diagnosis = this.patientCardData.diagnosis;
      this.EditForm.investigation = this.patientCardData.investigation;
      this.EditForm.surgery_date_time = this.formatNewDate(this.date);
      this.EditForm.patient_card_id = this.$route.params.id;
      this.EditForm.parent_id = this.$route.query.surgeryId;

      this.EditForm.doctors = this.selectedDoctors.map((doctor) => ({
        id: doctor.id,
        type: doctor.type,
      }));
      this.EditForm.doctor_assist = this.selectedDoctorAssistants.map((assistant) => ({
        id: assistant.id,
        type: assistant.type,
      }));
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      console.log("this.EditForm", this.EditForm);
      this.params.form = this.EditForm;
      this.params.path = "/patient-surgery";

      this.$store
        .dispatch("create", this.params)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "surgery-patient-history" });
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "success",
              variant: "success",
              text: "Surgery information added successfully",
            },
          });
        })
        .catch((error) => {
          this.loading = false;
          if (error.response?.status === 400) {
            Object.entries(error.response.data).forEach(([key, value]) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: value[0],
                },
              });
            });
          }
        });
    },
    async getDoctorAssistants() {
      try {
        const response = await this.getList("/doctorAssistants");
        this.doctorAssistants = response.data.data;
      } catch (error) {
        console.error("Error fetching doctor assistants:", error);
      }
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.doctor-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  text-align: center;
}

.role-selection {
  margin-top: 10px;
}

.role-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-checkbox >>> .custom-control-label {
  font-size: 14px;
  color: #333;
}

.role-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.role-checkbox >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
